module.exports = __webpack_public_path__ + "static/img/hh-dy.b2bdf76.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/hh-dy.jpg
// module id = 6e3q
// module chunks = 1